import type { NarrativeLocaleTableV0 } from './messages-ko';

export const NARRATIVE_MESSAGES_JA_V0: NarrativeLocaleTableV0 = {
  'home.hero.category': '会社のすべての仕事を一箇所でつなぐ運営システム',
  'home.hero.promise':
    '注文・購買・生産・承認のように会社で起きたことが担当者のやることになり、処理結果と証跡が記録として残ります。',
  'home.hero.differentiator':
    'ERPが終わった仕事を記録するなら、Inflomatrixは次にすべきことを作り、処理結果まで会社の記録につなげます。',
  'home.hero.ctaPrimary': '組織を始める',
  'home.hero.ctaSecondary': '実際の流れを見る',
  'home.hero.inviteHint': '招待コードのある組織のみ開始できます · オンボーディングで確認します。',
  'home.breakPoints.eyebrow': '現場で繰り返されること',
  'home.breakPoints.title': '「処理された?」を人にまた聞いているなら、このページが合っています',
  'home.breakPoints.intro':
    'チャットで注文を受け、エクセルに書き写し、完了は別に知らせる — ツールを増やすほどつながりは切れます。',
  'home.oneFlow.eyebrow': '一つにつながる流れ',
  'home.oneFlow.title': 'サイトに注文が入ると、担当者の業務箱にやることが表示されます',
  'home.oneFlow.intro':
    '顧客向けサイトと内部処理を一緒に運営する組織のために、注文が入った瞬間に担当者の業務箱にやることが生まれる流れを招待制で確認できます。',
  'home.proof.eyebrow': '証拠',
  'home.proof.title': '顧客画面と運営画面が一つの流れでつながります',
  'home.proof.intro':
    '下のスクリーンショットはdemo.staging.inflomatrix.appで新規の顧客注文一件を撮影したものです。状態は受付済み — 処理完了のスクリーンショットは別途撮影するまで主張しません。',
  'home.proof.scope':
    '訪問者が今見ているのは、招待制パイロットで確認した注文 → 業務箱 → 受付確認、この一区間です。すべての業種・すべての申込フォームに同じだとは言いません。',
  'home.moreThanOrders.eyebrow': '注文、それ以上',
  'home.moreThanOrders.title': 'ショップは注文を受けます。Inflomatrixは注文を処理し記録します。',
  'home.moreThanOrders.body':
    'ERPは終わった仕事を記録します。Inflomatrixは次の仕事を作って担当者につなげ、処理結果を再び会社の記録として残します。',
  'home.threeChanges.eyebrow': '変わる三つのこと',
  'home.threeChanges.title': '注文が記録につながる方法',
  'home.toolComparison.eyebrow': '比較',
  'home.toolComparison.title': '注文を受けることと、注文を処理して記録することは違います',
  'home.toolComparison.footnote':
    '招待制パイロットの範囲: 商品詳細 → 顧客注文 → 担当者業務箱の経路。すべてのフォーム・すべての業種に同じだとは言いません。',
  'home.sharedRecord.eyebrow': '一つの記録を共有',
  'home.sharedRecord.title': 'サイトから入った仕事が内部業務箱につながります',
  'home.sharedRecord.intro':
    '組織を一つ作ると、顧客が見るサイトと内部処理の業務箱が同じ記録の上でつながります。サイトが不要な組織（例: 内部専用チーム）は業務箱だけでも始められます。',
  'home.startNow.eyebrow': '今すぐ始められること',
  'home.startNow.title': '今確認できることと、一緒に準備することを分けて案内します',
  'home.startNow.subtitle': '証拠でお見せした項目と、これから一緒に作る項目を分けてお見せします。',
  'home.startNow.now.label': '今すぐ使えます',
  'home.startNow.prepare.label': '会社に合わせて一緒に準備します',
  'home.startNow.notYet.label': 'まだです',
  'home.ahead.eyebrow': 'これからの方向',
  'home.ahead.title': 'ループを先に証明し、その上により深い運営知能を積み上げます',
  'home.ahead.body':
    '今証明したのは、注文が担当者のやることになり、処理結果が記録として残る流れです。これからは繰り返される仕事を機械が先に気づいて人に提案する方向へ、そしていつか人と機械が同じ記録の上で一緒に働く方向へ進みます。今このページが示しているのは、その出発点です。',
  'home.finalCta.title': '今すぐ組織を始めましょう',
  'home.finalCta.body':
    '招待コードがあればすぐに始められます。実際の流れを先に見たい場合は証拠を確認してください。',
  'home.finalCta.ctaPrimary': '組織を始める',
  'home.finalCta.ctaSecondary': '実際の流れを見る',
  'capabilities.connectOperations.label': '運営の接続',
  'capabilities.connectOperations.problem': '注文・業務・処理がツールごとに切れます。',
  'capabilities.connectOperations.prepares':
    'サイト・業務箱・運営モジュールを一つの流れでつなぐ準備をします。',
  'capabilities.connectOperations.example': 'ゲスト注文が担当者の業務箱につながるループ',
  'capabilities.trustNumbers.label': '数字の信頼',
  'capabilities.trustNumbers.problem': '帳簿と現場の数量が一致しません。',
  'capabilities.trustNumbers.prepares': '会計・数量記録を同じ運営フローに載せます。',
  'capabilities.trustNumbers.example': '入荷・在庫・会計収束（ステージング検証）',
  'capabilities.authorityEvidence.label': '権限と証跡',
  'capabilities.authorityEvidence.problem': '誰がなぜ実行したかを後から説明しにくいです。',
  'capabilities.authorityEvidence.prepares':
    '提案→権限→証跡→実行の文法を組織に合わせて準備します。',
  'capabilities.authorityEvidence.example': '承認記録と実行レシートが分離した統制ループ',
  'capabilities.physicalContext.label': '現場連携',
  'capabilities.physicalContext.problem': '現場の位置・対象がシステムとつながりません。',
  'capabilities.physicalContext.prepares':
    '現場スキャン・物理アクセスのコンテキストを範囲限定で準備します。',
  'capabilities.physicalContext.example': '倉庫の物品と場所をスキャンでつなぐ流れ',
  'capabilities.temporalContext.label': '予定連携',
  'capabilities.temporalContext.problem': 'いつ何をするかの計画がシステムに残りません。',
  'capabilities.temporalContext.prepares': '時間・計画ランタイムを範囲限定で準備します。',
  'capabilities.temporalContext.example': '定期業務が予定に合わせてタスクになる流れ',
  'capabilities.governedAi.label': '統制されたAI',
  'capabilities.governedAi.problem': 'AI提案が権限・証跡なしでそのまま実行されると危険です。',
  'capabilities.governedAi.prepares': '統制された範囲でAIが分析・提案し、実行までつなぎます。',
  'capabilities.governedAi.example':
    'マルチエージェント長期作業（ステージング、無制限自律ではない）',
  'capabilities.humanoidVision.label': 'ヒューマノイド・ビジョン',
  'capabilities.humanoidVision.problem': '将来の物理アクターを同じ運営言語に載せる準備が必要です。',
  'capabilities.humanoidVision.prepares':
    'いまはビジョン・計画としてのみ述べます。実世界実行は主張しません。',
  'capabilities.humanoidVision.example':
    'アクションコンテキストとデジタルツイン（コンテキスト限定）',
  'claim.qualifier.proven': '検証済み',
  'claim.qualifier.preview': 'プレビュー',
  'claim.qualifier.planned': '予定',
  'claim.qualifier.vision': 'ビジョン',
  'maturity.current': '現在',
  'maturity.nearTerm': '近い計画',
  'maturity.longTerm': '長期ビジョン',
  'genesis.stage1.title': 'まず、どのような組織かを理解します',
  'genesis.stage1.subtitle':
    '規模と運営形態を選ぶと、残りを合わせて用意します。入力情報でサイト・業務箱の下書きを自動準備します。',
  'genesis.stage1.cta.primary': '続ける',
  'genesis.stage1.cta.secondary': 'よくわからない — 推薦を受ける',
  'genesis.stage1.trust': '選んだ内容はいつでも変えられ、いまの選択が最終ではありません。',
  'genesis.stage2.title': 'すでにある資料を上げると手入力を減らせます',
  'genesis.stage2.subtitle':
    '会社紹介・既存サイトURL・商品一覧など何でも構いません。完璧でなくて大丈夫です — ある分だけください。',
  'genesis.stage2.trust': '上げた資料は下書き作成にのみ使い、確定前には何も公開しません。',
  'genesis.stage2.claimBoundary': '自動抽出は下書きです — 次のステップで直接確認します。',
  'genesis.stage2.source.url': '既存サイトURL',
  'genesis.stage2.source.file': '会社紹介・文書（ファイル名メモ）',
  'genesis.stage2.source.catalog': '商品・サービス一覧ヒント',
  'genesis.stage2.source.optional': 'すべて任意です。空欄のまま続けられます。',
  'genesis.stage3.title': '資料から次の情報を見つけました。正しければ確認、違えば直してください',
  'genesis.stage3.trust': 'AIが埋めた値は灰色バッジで表示されます。確認するまでは推定です。',
  'genesis.stage3.claimBoundary':
    '自動入力は制御されたアシスト範囲です。無制限自律ではありません。',
  'genesis.stage3.badge.ai': 'AI推薦 · 出典: {source}',
  'genesis.stage3.badge.confirmed': '確認済み',
  'genesis.stage3.empty':
    '確認する抽出項目はまだありません。入力を続けるか資料を追加してください。',
  'genesis.stage4.title': 'この組織に合う運営能力を推薦します',
  'genesis.stage4.subtitle':
    '推薦能力はA–Fのみです。合わなければ後回しにしたり詳細を確認できます。',
  'genesis.stage4.why': '推薦根拠: 入力した規模・運営形態',
  'genesis.stage4.cta.accept': '推薦を受け入れる',
  'genesis.stage4.cta.later': 'あとで',
  'genesis.stage4.cta.details': '詳細を見る',
  'genesis.stage4.minimumFloor': '運営接続と権限・証跡は最小基本として含まれます。',
  'genesis.stage5.title': '今すぐ始めても大丈夫です',
  'genesis.stage5.subtitle':
    '空欄があっても、情報不足は設定失敗を意味しません。分類を確認してください。',
  'genesis.stage5.trust': '空欄でも組織作成はできます。公開はあなたが押したときだけ行われます。',
  'genesis.stage5.insufficientInfo': '情報不足でも構成失敗ではありません。',
  'genesis.stage5.gap.mustResolve': '最初の業務を妨げるため、今すぐ解決が必要です。',
  'genesis.stage5.gap.useDefault': '推薦デフォルトを使えば今すぐ進められます。',
  'genesis.stage5.gap.configureLater': 'あとでBusiness画面で設定できます。',
  'genesis.stage5.gap.notNeeded': '最初の業務には不要です。',
  'genesis.stage5.gap.insufficientInfo': '情報不足は設定失敗ではありません。',
  'genesis.stage6.title': 'この内容で組織を作ります。作成前に一度確認してください',
  'genesis.stage6.trust': '確認を押すまで何も作成されません。',
  'genesis.stage6.irreversible': '組織アドレス（{org}.inflomatrix.app）は確定されます。',
  'genesis.stage6.cta.primary': '組織を作る',
  'genesis.stage6.cta.secondary': '前のステップを修正',
  'genesis.stage6.item.workspace': 'ワークスペース・組織アドレス',
  'genesis.stage6.item.flows': '運営フロー（Flow）',
  'genesis.stage6.item.objects': '業務対象（Object）',
  'genesis.stage6.item.authority': '権限・承認（Authority）',
  'genesis.stage6.item.evidence': '証跡（Evidence）',
  'genesis.stage6.item.aiScope': 'AI範囲（制御されたアシスト）',
  'genesis.stage6.item.excluded': '今回の作成から除外される項目',
  'genesis.stage7.title': '会社の運営構造を準備しています',
  'genesis.stage7.subtitle': '技術ステップではなく、業務価値単位で進捗を示します。',
  'genesis.stage7.trust': '失敗したステップがあれば、ここですぐお知らせします。',
  'genesis.stage7.step.workspace': 'ワークスペース準備',
  'genesis.stage7.step.teamPermissions': 'チーム・権限準備',
  'genesis.stage7.step.workflows': '運営フロー準備',
  'genesis.stage7.step.docsEvidence': '文書・証跡準備',
  'genesis.stage7.step.firstWork': '最初の業務準備',
  'genesis.stage7.step.verify': '完了確認',
  'genesis.stage8.title': '最初の業務を始める準備ができました',
  'genesis.stage8.subtitle':
    '推薦の最初の業務、対象・出典、役割、証跡、開始CTAを確認してください。後回し項目は別に表示します。',
  'genesis.stage8.finishLine': 'FIRST_OPERATION_READY',
  'genesis.stage8.cta.primary': '最初の業務を開始',
  'genesis.stage8.cta.secondary': 'あとで設定する項目を見る',
  'genesis.stage8.laterItems': '公開サイト・詳細権限・追加モジュールはあとで設定できます。',
  'genesis.stage8.humanoidSecondary':
    '将来の物理アクター（ヒューマノイド）叙述は補助案内であり、いまの最初の業務条件ではありません。',
  'genesis.stage8.firstOp.procurementReceiving.why':
    '入荷・検収フローが入力シグナルによく合います。',
  'genesis.stage8.firstOp.procurementReceiving.objects': '発注・入荷対象品目',
  'genesis.stage8.firstOp.procurementReceiving.role': '入荷担当者',
  'genesis.stage8.firstOp.procurementReceiving.evidence': '数量・検収証跡',
  'genesis.stage8.firstOp.catalogOrder.why': 'カタログ注文ループが入力シグナルによく合います。',
  'genesis.stage8.firstOp.catalogOrder.objects': '商品・ゲスト注文',
  'genesis.stage8.firstOp.catalogOrder.role': '注文処理担当者',
  'genesis.stage8.firstOp.catalogOrder.evidence': '注文受付レシート',
  'genesis.stage8.firstOp.general.why': '組織の基本情報から一般の最初の業務を準備します。',
  'genesis.stage8.firstOp.general.objects': '組織・業務箱の基本項目',
  'genesis.stage8.firstOp.general.role': '組織管理者',
  'genesis.stage8.firstOp.general.evidence': '構成完了記録',
  'genesis.stage8.firstOp.procurementReceiving.label': '入荷・検収業務',
  'genesis.stage8.firstOp.catalogOrder.label': '注文処理業務',
  'genesis.stage8.firstOp.general.label': '組織の最初の業務準備',
  'genesis.adaptive.dontKnow': 'よくわからない — 推薦を受ける',
  'gap.class.MUST_RESOLVE_NOW': '今すぐ解決が必要',
  'gap.class.USE_RECOMMENDED_DEFAULT': '推薦デフォルトを使用',
  'gap.class.CONFIGURE_LATER': 'あとで設定',
  'gap.class.NOT_NEEDED_FOR_FIRST_OPERATION': '最初の業務に不要',
};
